import { hasScopedPermission, GrantsType } from '../../Shared/utils/auth';

export const updatePartnerPermission = (grants: GrantsType) => {
  const permission = 'partners.update';

  return hasScopedPermission(grants, 'partner', permission);
};
